
import React, { createContext, useState } from "react";

export const UserContext = createContext();

export const UserContextProvider = props => {
  const [type, setType] = useState(null);
  const [vehicle, setVehicle] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [configurationId, setConfigurationId] = useState(null);

  const getAnswers = () => answers
  const setAnswer = (id, answer) => {
    if(Number.isInteger(id) && answer) {
      const a = answers.filter( o => o.id != id );
      a.push({ id: id, answer: answer });
      setAnswers(a);
    }
  };

  return (
    <UserContext.Provider 
      value={{ 
        type, 
        setType, 
        getAnswers,
        setAnswer,
        setAnswers,
        configurationId, 
        setConfigurationId,
        vehicle,
        setVehicle
      }}>
      {props.children}
    </UserContext.Provider>
  );
};
